import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import { openInBrowser } from '@/utils/bridge';
import styles from './style.less';

export default class user extends Component {
  render() {
    return (
      <DocumentTitle title="隐私政策">
        <div className={styles.WordSection1}>
          <h2>
            <strong>《网心云隐私政策》</strong>
          </h2>
          <p>生效日期：【2023】年【07】月【20】日</p>
          <p>
            【特别提示】请仔细阅读《隐私政策》（尤其是加粗划线的内容）并确定了解我们对您个人信息的收集与处理（包括使用、保存、共享、转让）规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询。
            <strong>
              当您点击同意本隐私政策，或以适当的方式开始、继续使用我们的产品或服务，且未通过适当的方式联系我们并表达相反意见的，我们将视为您充分理解并同意本政策。
            </strong>
          </p>
          <p>
            本应用尊重并保护所有使用服务用户的个人隐私权。本应用会按照本隐私权政策的规定收集、使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。本隐私权政策属于《网心云用户协议》不可分割的一部分，本政策未尽事宜适用《网心云用户协议》。
          </p>
          <p>本政策将帮助您了解以下内容：</p>
          <ul>
            <li>一、信息获取</li>
            <li>二、信息使用</li>
            <li>三、信息披露</li>
            <li>四、信息存储和交换</li>
            <li>五、Cookie的使用</li>
            <li>六、信息安全</li>
            <li>七、本隐私政策的更改</li>
            <li>八、个人资料的保护及修改</li>
            <li>九、未成年人的个人信息保护</li>
            <li>
              <strong>十、免责声明（非常重要）</strong>
            </li>
            <li>附件一《账户注销须知》</li>
          </ul>
          <p>
            如对本隐私政策或相关事宜有任何问题、异议、评论、建议、担忧、投诉或举报，您可随时通过官方客服与我们联系。
          </p>
          <p>
            网心云运营者：深圳市网心科技有限公司
            <br />
            注册地址：深圳市前海深港合作区前湾一路1号A栋201室
            <br />
            个人信息保护部门联系方式：
            <br />
            邮箱：wxygo@onething.net
            <br />
            在线客服：网心云APP首页_右下角客服
          </p>
          <h4>
            <strong>1．信息获取</strong>
          </h4>
          <p>
            (a)
            在您注册本应用帐号时，您根据本应用要求提供的手机号及设备连接信息，本应用采取克制、最小、必要性使用原则，除为应用使用功能、应用市场要求、用户主动披露及法律要求外，不会主动收集用户信息；
          </p>
          <p>
            (b)
            在您登录本应用账号、使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息等，包括：IP地址、浏览器的类型、网络信息、使用的语言、访问日期和时间；软硬件特征信息（包括
            <strong>硬件型号、SIM卡序列号、设备MAC地址、设备ID</strong>）；个人常用设备信息（
            <strong>
              如IMEI/android ID/IDFA/OPENUDID/GUID、IMSI信息等在内的描述个人常用设备基本情况的信息
            </strong>
            ）；
            <strong>
              操作系统、操作系统类型、操作系统版本号、设备制造商、设备型号、设备序列号、唯一设备识别码；
            </strong>
            您需求的网页记录等数据；
          </p>
          <p>
            (c)
            在您进行实名认证或选择与本应用合作的第三方支付机构（以下称“支付机构”）所提供的提现服务，本应用需要收集您的
            <strong>银行卡号、支付宝账号、姓名/名称、身份证号码/统一社会信用代码等</strong>
            相关个人信息，同时我们需要将前述个人信息与这些支付机构共享以实现其确认您的提现指令并完成提现的目的。
          </p>
          <p>
            <strong>
              (d)
              为了实现统计分析、消息推送、账号注册及登录、质量跟踪等功能，本应用接入了第三方SDK。部分第三方SDK可能会调用您的设备权限、获取您的相关信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息、手机号码等）。不同的第三方SDK所调用的设备权限类型以及所获得的信息可能不同，具体如下：
            </strong>
          </p>
          <ul>
            <li>
              <strong>
                ①第三方SDK名称：友盟统计、推送SDK、友盟分享SDK
                <br />
                主体：友盟同欣（北京）科技有限公司
                <br />
                使用目的：统计分析、消息推送
                <br />
                收集信息：采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息
                <br />
                使用场景：用于向用户设备推送消息
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({ url: 'https://developer.umeng.com/docs/147377/detail/209997' })
                  }
                >
                  https://developer.umeng.com/docs/147377/detail/209997
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ②第三方SDK名称：支付宝SDK
                <br />
                主体：支付宝（中国）网络技术有限公司
                <br />
                使用目的：使用支付宝账号快速登录
                <br />
                收集信息：采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息
                <br />
                使用场景：用户实名认证后进行提现
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://opendocs.alipay.com/open/54/01g6qm?pathHash=01459d85',
                    })
                  }
                >
                  https://opendocs.alipay.com/open/54/01g6qm?pathHash=01459d85
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ③第三方SDK名称：Bugly SDK
                <br />
                主体：深圳市腾讯计算机系统有限公司
                <br />
                使用目的：Crash监控、崩溃分析等质量跟踪服务
                <br />
                收集信息：采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息
                <br />
                使用场景：用于分析用户设备崩溃日志，进行问题处理
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url:
                        'https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56',
                    })
                  }
                >
                  https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ④第三方SDK名称：有赞 SDK
                <br />
                主体：深圳有赞科技有限公司
                <br />
                使用目的：用于有赞商城集成
                <br />
                收集信息：采集常用设备标识信息（BSSID/设备序列号/IMEI/MAC地址/SSID/IMSI）、本地存储权限
                <br />
                使用场景：用户通过网心云APP查看网心云有赞店铺优惠券、查看订单等
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://doc.youzanyun.com/resource/doc/3190',
                    })
                  }
                >
                  https://doc.youzanyun.com/resource/doc/3190
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑤第三方SDK名称：小米推送 SDK
                <br />
                主体：小米科技有限责任公司
                <br />
                使用目的：向小米设备推送信息
                <br />
                收集信息：采集常用设备信息（设备厂商、设备型号、设备内存、操作系统版本、小米推送SDK版本、设备归属地（国家或地区）、SIM卡运营商名称、当前网络类型等
                <br />
                使用场景：新消息到达设备时提醒用户查看
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://dev.mi.com/distribute/doc/details?pId=1534',
                    })
                  }
                >
                  https://dev.mi.com/distribute/doc/details?pId=1534
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑥第三方SDK名称：华为推送 SDK
                <br />
                主体：华为终端有限公司
                <br />
                使用目的：向华为设备推送信息
                <br />
                收集信息：AppID，推送服务和HMS Core应用版本号、设备类型等
                <br />
                使用场景：新消息到达设备时提醒用户查看
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url:
                        'https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177',
                    })
                  }
                >
                  https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑦第三方SDK名称：OPPO 推送 SDK
                <br />
                主体：OPPO广东移动通信有限公司
                <br />
                使用目的：向OPPO设备推送信息
                <br />
                收集信息：采集常用设备相关信息（如IMEI或OAID，Serial Number，IMSI，User ID，Android
                ID，Google Advertising ID,
                手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果、通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）
                <br />
                使用场景：新消息到达设备时提醒用户查看
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://open.oppomobile.com/new/developmentDoc/info?id=10288',
                    })
                  }
                >
                  https://open.oppomobile.com/new/developmentDoc/info?id=10288
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑧第三方SDK名称：VIVO 推送 SDK
                <br />
                主体：维沃移动通信有限公司
                <br />
                使用目的：向VIVO设备推送信息
                <br />
                收集信息：正在运行的应用列表信息、手机存储权限
                <br />
                使用场景：新消息到达设备时提醒用户查看
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://www.vivo.com.cn/about-vivo/privacy-policy',
                    })
                  }
                >
                  https://www.vivo.com.cn/about-vivo/privacy-policy
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑨第三方SDK名称：魅族推送 SDK
                <br />
                主体：珠海市魅族通讯设备有限公司
                <br />
                使用目的：向魅族设备推送信息
                <br />
                收集信息：设备相关信息，如手机品牌、手机型号、系统版本、系统语言，以及设备标识符（通过相关标识符生成应用间不相关的用户标识：push
                ID）等
                <br />
                使用场景：新消息到达设备时提醒用户查看
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://open.flyme.cn/docs?id=202',
                    })
                  }
                >
                  https://open.flyme.cn/docs?id=202
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑩第三方SDK名称：腾讯分享 SDK （微信、QQ）
                <br />
                主体：深圳市腾讯计算机系统有限公司
                <br />
                使用目的：用于用户将网心云APP活动内容分享到QQ、微信
                <br />
                收集信息：读写外部存储权限
                <br />
                使用场景：当用户选择将内容分享至微信、QQ时
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://privacy.qq.com/policy/tencent-privacypolicy',
                    })
                  }
                >
                  https://privacy.qq.com/policy/tencent-privacypolicy
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑪第三方SDK名称：新浪分享 SDK
                <br />
                主体：北京微梦创科网络技术有限公司
                <br />
                使用目的：用于帮助用户将信息分享到微博
                <br />
                收集信息：采集常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息、手机号码
                <br />
                使用场景：当用户选择将内容分享至微博时
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://m.weibo.cn/c/privacy',
                    })
                  }
                >
                  https://m.weibo.cn/c/privacy
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑫第三方SDK名称：z-xing SDK
                <br />
                主体：微软(中国)有限公司
                <br />
                使用目的：二维码、条形码识别
                <br />
                收集信息：相机信息
                <br />
                使用场景：用户使用网心云APP扫描二维码绑定账号
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://github.com/yipianfengye/android-zxingLibrary',
                    })
                  }
                >
                  https://github.com/yipianfengye/android-zxingLibrary
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑬第三方SDK名称：岳鹰 SDK
                <br />
                主体：广州市动景计算机科技有限公司
                <br />
                使用目的：实现数据监测、崩溃日志
                <br />
                收集信息：设备信息、崩溃日志
                <br />
                使用场景：当APP发生触发崩溃或无响应时
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url:
                        'https://terms.alicdn.com/legal-agreement/terms/suit_bu1_uc/suit_bu1_uc202108181503_97480.html',
                    })
                  }
                >
                  https://terms.alicdn.com/legal-agreement/terms/suit_bu1_uc/suit_bu1_uc202108181503_97480.html
                </span>
              </strong>
            </li>
            <li>
              <strong>
                ⑭第三方SDK名称：腾讯x5浏览器内核
                <br />
                主体：深圳市腾讯计算机系统有限公司
                <br />
                使用目的：移动浏览场景体验优化
                <br />
                收集信息：常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、设备制造商、网络类型、网络状态、手机操作系统、屏幕尺寸、ip地址
                <br />
                使用场景：嵌入第三方SDK，SDK收集传个人信息、设备信息
                <br />
                共享方式：SDK本机采集
                <br />
                隐私政策链接：
                <span
                  className={styles.link}
                  onClick={() =>
                    openInBrowser({
                      url: 'https://x5.tencent.com/tbs/guide/develop.html#5',
                    })
                  }
                >
                  https://x5.tencent.com/tbs/guide/develop.html#5
                </span>
              </strong>
            </li>
          </ul>
          <p>
            <strong>(e) 设备权限收集说明</strong>
          </p>
          <p>
            （1）<strong>存储权限（读写存储）：</strong>
            为了存储必要的应用配置文件以及您所选择下载、更新的内容、报表，或读取您需要上传、同步的内容，需要调用您的存储权限。
          </p>
          <p>
            （2）<strong>相机权限：</strong>
            当您使用拍摄或扫描相关功能时（如“扫一扫”识别二维码/绑定设备时），我们需要调用您的相机权限。
          </p>
          <p>
            (f) 如您希望支持产品功能的优化，
            {/* 或获取个性化的服务， */}
            您可自主选择向我们提供或允许我们收集以下信息，包括：
          </p>
          <p>
            （1）<strong>意见反馈</strong>
            <br />
            您可以向我们反馈服务中遇到的问题，我们会
            <strong>收集您的联系方式以及反馈的问题内容</strong>，以便快速定位解决问题。
          </p>
          <p>
            （2）<strong>消息推送</strong>
            <br />
            为了完成信息推送服务，我们会收集全局通用能力涉及的信息。您可以选择是否接收app的推送消息，以及接收哪些种类的消息。您可以通过“我的”—“设置”中对“消息提醒”进行关闭。
          </p>
          <p>(g) 您充分知晓并理解，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</p>
          <p>（1）与国家安全、国防安全有关的；</p>
          <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
          <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
          <p>
            （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
          </p>
          <p>（5）所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
          <p>
            （6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
          </p>
          <p>（7）根据您的要求签订合同所必需的；</p>
          <p>（8）为合法的新闻报道所必需的；</p>
          <p>
            （9）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术
            研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          </p>
          <p>（10）法律法规规定的其他情形。</p>
          <p>(h) 您了解并同意，以下信息不适用本隐私权政策：</p>
          <p>(1) 您在使用本应用平台提供的搜索服务时输入的关键字信息；</p>
          <p>
            (2)
            本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；
          </p>
          <p>(3) 违反法律规定或违反本应用规则行为及本应用已对您采取的措施。</p>
          <p>(i) 其他</p>
          <p>
            请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，我们合作的第三方主体可能会向您提供服务，当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。
          </p>
          <h4>
            <strong>2．信息使用</strong>
          </h4>
          <p>
            (a)
            本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
          </p>
          <p>
            (b)
            本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。
          </p>
          <p>
            {/* 为服务用户的目的，本应用可能通过使用您去标识化处理后的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。 */}
            (c)
            为服务用户的目的，本应用可能向您推送本应用产品及相关服务信息，您可以前往应用内【我的】-【设置】关闭消息通知。
          </p>
          <h4>
            <strong>3．信息披露</strong>
          </h4>
          <p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
          <p>(a) 经您事先同意，向第三方披露；</p>
          <p>(b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</p>
          <p>(c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
          <p>
            (d) 如您出现违反有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；
          </p>
          <p>
            (e)
            如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
          </p>
          <p>
            (f)
            在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决；
          </p>
          <p>(g) 其它本应用根据法律、法规或者网站政策认为合适的披露。</p>
          <h4>
            <strong>4．信息存储和交换</strong>
          </h4>
          <p>
            本应用收集的有关您的信息和资料将去标识化和加密后保存在本应用及（或）其关联公司中国境内的服务器上。
          </p>
          <h4>
            <strong>5．Cookie的使用</strong>
          </h4>
          <p>
            (a) 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies
            ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。
            {/* 本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。 */}
          </p>
          <p>
            (b)
            您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。
          </p>
          <p>(c) 通过本应用所设cookies所取得的有关信息，将适用本政策。</p>
          <h4>
            <strong>6．信息安全</strong>
          </h4>
          <p>
            本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。{' '}
          </p>
          <h4>
            <strong>7．本隐私政策的更改</strong>
          </h4>
          <p>
            (a)
            如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。
          </p>
          <p>
            (b)
            本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知、更新提示等形式告知。
          </p>
          <h4>
            <strong>8．个人资料的保护及修改</strong>
          </h4>
          <p>
            (a)
            请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。
          </p>
          <p>
            (b)
            当您需要更新您的个人信息时，或发现我们处理您的个人信息有错误时，您可以通过登录本应用，通过帮助与反馈界面对应入口、客服或本应用公开的其他联系方式联系本应用更新或更正其中的部分个人信息。
          </p>
          <p>(c) 您可以通过访问本应用客服系统、拨打我们的客服电话联系我们申请注销账号。</p>
          <h4>
            <strong>9．未成年人的个人信息保护</strong>
          </h4>
          <p>
            (a)
            本应用非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。本应用根据国家相关法律法规的规定保护未成年人的个人信息。
          </p>
          <p>
            (b)
            对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
          </p>
          <p>
            (c)
            如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。
          </p>
          <h4>
            <strong>10．免责声明（非常重要）</strong>
          </h4>
          <p>
            <strong className={styles['underline-text']}>
              (a)
              当您同意并以适当的方式开始，或者继续使用我们的产品或服务的，且您未通过适当的方式联系我们并表达相反意见的，我们将视为您充分理解并同意本政策。
            </strong>
          </p>
          <p>
            <strong className={styles['underline-text']}>
              (b)
              请您理解，互联网并非绝对安全的环境，电子邮件、即时通讯、社交软件、交易平台等与其他用户的交流方式无法确定是否完全加密，请您在进行交互使用时，注意保护您个人信息的安全。
            </strong>
          </p>
          <p>
            <strong className={styles['underline-text']}>
              (c)
              请您理解，由于计算机及互联网技术的飞速发展及同步速度的限制，可能存在或出现各种恶意或非恶意的攻击手段。虽然我们持续致力于提升和加强安全措施，以保护您的个人信息免遭意外或破坏，但仍无法始终保证您的个人信息的百分之百安全。
            </strong>
          </p>
          <p>
            <strong className={styles['underline-text']}>
              (d)
              请您理解，您使用产品或服务时所用的系统和通讯网络，或硬件设备等我们均无法控制，请您了解并注意保护您的个人信息安全。除非本隐私政策有其他规定，为了保护您的人身及财产安全，我们特别提醒您不要通过公共网络，向我们或任何以我们名义为您提供服务的第三方，提供您的财产状况、健康生理、账户密码或验证码、个人轨迹、通信内容等信息。
            </strong>
          </p>
          <p>
            <strong className={styles['underline-text']}>
              特别提示：本《网心云隐私政策》将于发布之日正式生效，除非本应用根据相关法律法规及平台运营对本隐私政策作出调整并发布新的隐私政策，否则本隐私政策一直有效。{' '}
            </strong>
          </p>
          <h3 style={{ textAlign: 'center' }}>
            <strong>附件一 《账户注销须知》</strong>
          </h3>
          <p>
            【特别提示】当您按照注销页面提示填写信息、阅读并同意本《账户注销须知》《网心云用户协议》《网心云隐私政策》等本应用平台的相关条款与条件且完成全部注销程序后，即表示您已充分阅读、理解并接受上述协议的全部内容。{' '}
          </p>
          <p>
            阅读本《账户注销须知》的过程中，如果您不同意相关任何条款和条件约定，您可以通过网上客服电话联系我们。
          </p>
          <p>亲爱的本应用平台用户：</p>
          <p>我们对您注销本应用账户的决定深表遗憾与歉意。</p>
          <p>
            我们在此善意的提醒您，您注销本应用账户的行为会给您的售后维权带来诸多不便，且注销本应用账户后，您的个人信息我们会根据法律法规的要求及《网心云隐私政策》的约定进行删除或匿名化处理。{' '}
          </p>
          <p>1、如果您仍执意注销账户，您的账户需同时满足以下条件：</p>
          <ul>
            <li>
              （1）在最近一个月内，账户没有进行更改密码、更改绑定信息等敏感操作，账户没有被盗、被封等风险；
            </li>
            <li>
              （2）账户在本应用中无资产和虚拟权益（包括但不限于收益金额、账户余额、优惠券等）；
            </li>
            <li>（3）账户内无未完成的订单、服务；</li>
            <li>（4）账户内订单或服务无任何纠纷，包括投诉举报或被投诉举报；</li>
          </ul>
          <p>如果您确定注销本应用账户，并已操作完成注销事宜，将表示您对上述事项均予以确认。</p>
          <p>
            2、在注销本应用账户期间，如果您的本应用账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，本应用有权自行终止本本应用账户的注销，且无需另行得到您的同意。{' '}
          </p>
          <p>
            3、注销本应用账户后，您将无法再使用该账户登录本应用平台，也将无法找回您本应用账户中该账户相关的任何内容或信息，包括但不限于：
          </p>
          <ul>
            <li>
              （1）您将无法登录、使用本应用账户登录本应用平台，您曾获得的余额、优惠券、积分、资格、订单等视为您自行放弃，将无法继续使用；
            </li>
            <li>
              （2）本应用账户的个人资料和历史信息（包括但不限于用户名、头像、购物记录、关注信息等）都将无法找回；
            </li>
            <li>（3）您理解并同意，本应用无法协助您重新恢复前述服务。</li>
          </ul>
          <p>4、您注销账户的渠道如下：我的-设置-账号与安全-账号注销。</p>
          <p>5、如果您需要继续使用本应用服务，您可以重新注册本应用账户。</p>
        </div>
      </DocumentTitle>
    );
  }
}
